import {svgIconWrapper} from '../svg-icon-wrapper';

import AirtableRegular from './airtable-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <AirtableRegular {...props} />;
}

SvgComponent.iconName = 'airtableRegular';

export const AirtableRegularIcon = svgIconWrapper(SvgComponent);
